"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TooltipFlyout;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _image = require("../image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _button = _interopRequireDefault(require("@ux/button"));
var _list = _interopRequireDefault(require("../list"));
var _text = _interopRequireDefault(require("@ux/text"));
var _mobileFlyout = _interopRequireDefault(require("./mobile-flyout"));
var _icon = require("@site/pattern-library-utils/icon");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
var _closeButton = _interopRequireDefault(require("../close-button"));
var _base = require("@site/pattern-library-utils/base.functions");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */
/* eslint-disable no-undefined */

const Parent = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Parent",
  class: "core-pzaxyne"
});
const FlyoutContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlyoutContent",
  class: "core-filahqv"
});
const FlyoutImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyImage)({
  name: "FlyoutImage",
  class: "core-f5rx9qj"
});
const CloseButtonWrapper = /*#__PURE__*/(0, _react2.styled)(_closeButton.default)({
  name: "CloseButtonWrapper",
  class: "core-cvkkhw8"
});
const FlyoutContainer = /*#__PURE__*/(0, _react2.styled)(_mobileFlyout.default)({
  name: "FlyoutContainer",
  class: "core-f1mg52ht"
});
const BreakdownContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BreakdownContent",
  class: "core-b1x9t3jn"
});
const BreakdownContentItem = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "BreakdownContentItem",
  class: "core-b1e7hdgt"
});
const TotalPriceContent = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "TotalPriceContent",
  class: "core-t1uecrq1"
});

/**
 * TooltipFlyout Component.
 *
 * @param {Object} props React props
 * @param {string} props.id TooltipFlyout content id
 * @param {string} props._name Tracking name
 * @param {string} [props.ariaLabel='flyout'] Aria label
 * @param {string} [props.closeButtonAriaLabel='close-flyout'] Close button aria label
 * @param {Object} [props.image={}] Image object
 * @param {string} props.image.url Image URL
 * @param {string} props.image.altText Image alt text
 * @param {string} props.flyoutTitle Flyout title
 * @param {string} props.flyoutDescription Flyout description
 * @param {Array} [props.flyoutList=[]] Flyout list items
 * @param {Array} [props.breakdownList] Breakdown list items
 * @param {string} [props.flyoutBreakdownTitle] Title for breakdown section
 * @param {string} [props.flyoutBreakdownStrikethroughPrice] Strikethrough price for breakdown
 * @param {string} [props.flyoutBreakdownPrice] Price for breakdown
 * @param {Element} [props.portalElem=null] Portal element
 * @param {string} [props.partial=''] Partial string for mobile flyout
 * @param {string} [props.trigger='click'] Trigger type for opening the flyout ('click' or 'hover')
 * @returns {React.ReactElement} TooltipFlyout Component
 * @public
 */
function TooltipFlyout({
  id,
  _name,
  ariaLabel = 'flyout',
  closeButtonAriaLabel = 'close-flyout',
  image = {},
  flyoutTitle,
  flyoutDescription,
  flyoutList = [],
  breakdownList,
  portalElem = null,
  flyoutBreakdownTitle,
  flyoutBreakdownStrikethroughPrice,
  flyoutBreakdownPrice,
  partial = '',
  trigger = 'click',
  className = ''
}) {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const {
    width
  } = (0, _base.useWindowSize)();
  const trackingAttributes = _tracking.default.create(_name, true, false);
  const hoverOnDesktop = trigger === 'hover' && width > _breakpoints.size.tabletLg;
  const toggleHandler = (0, _react.useCallback)(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);
  const openHandler = (0, _react.useCallback)(() => {
    setIsOpen(true);
  }, []);
  const closeHandlerInternal = (0, _react.useCallback)(() => {
    setIsOpen(false);
  }, []);
  const closeHandler = evt => {
    const triggerEl = trackingAttributes?.ref?.current;
    if (evt instanceof MouseEvent && evt?.target === triggerEl) {
      return;
    }
    setIsOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement(Parent, null, /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    "data-cy": "flyout-trigger",
    design: "stateless",
    id: `id-${id}`,
    "aria-label": ariaLabel,
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "help"
    }),
    onClick: toggleHandler,
    onMouseEnter: hoverOnDesktop ? openHandler : undefined,
    onMouseLeave: hoverOnDesktop ? closeHandlerInternal : undefined
  }, trackingAttributes)), /*#__PURE__*/_react.default.createElement(FlyoutContainer, {
    id: `id-${id}`,
    isOpen: isOpen,
    closeButtonAriaLabel: closeButtonAriaLabel,
    closeHandler: closeHandler,
    anchorRef: trackingAttributes?.ref,
    portalElem: portalElem || global?.window?.document?.body,
    uxFlyoutProps: {
      placement: 'top',
      arrow: true,
      strategy: 'fixed'
    },
    className: className,
    partial: partial
  }, /*#__PURE__*/_react.default.createElement(FlyoutContent, {
    "data-cy": "flyout-content"
  }, image?.url && /*#__PURE__*/_react.default.createElement(FlyoutImage, (0, _extends2.default)({
    dataCy: "flyout-image"
  }, image)), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    "data-cy": "flyout-title",
    text: flyoutTitle,
    size: 1
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    "data-cy": "flyout-description",
    text: flyoutDescription,
    size: -1
  }), flyoutList && /*#__PURE__*/_react.default.createElement(_list.default, {
    dataCy: "flyout-list",
    layout: "headline-list",
    items: flyoutList.map(item => ({
      ...item
    })),
    textAlign: "start",
    iconColor: _intents.default.ux.box.foregroundColor
  })), breakdownList && /*#__PURE__*/_react.default.createElement(BreakdownContent, null, flyoutBreakdownTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    className: "breakdown-includes",
    text: flyoutBreakdownTitle,
    size: -1
  }), breakdownList.map((item, index) => /*#__PURE__*/_react.default.createElement(BreakdownContentItem, {
    key: index,
    "data-cy": "breakdown-item"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "action",
    "data-cy": "breakdown-content",
    text: item?.content,
    size: -1
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "action",
    "data-cy": "breakdown-price",
    text: item?.price,
    size: -1
  }))), (flyoutBreakdownPrice || flyoutBreakdownStrikethroughPrice) && /*#__PURE__*/_react.default.createElement(TotalPriceContent, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    className: "strikethrough",
    "data-cy": "breakdown-strikethrough-price",
    text: flyoutBreakdownStrikethroughPrice,
    size: -1
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "action",
    "data-cy": "breakdown-price",
    text: flyoutBreakdownPrice,
    size: 2
  }))), !hoverOnDesktop && /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, {
    onClose: closeHandler
  })));
}
TooltipFlyout.propTypes = {
  id: _propTypes.default.string.isRequired,
  _name: _propTypes.default.string.isRequired,
  ariaLabel: _propTypes.default.string,
  closeButtonAriaLabel: _propTypes.default.string,
  image: _propTypes.default.shape(_image.imgPropShape),
  flyoutTitle: _propTypes.default.string.isRequired,
  flyoutDescription: _propTypes.default.string.isRequired,
  flyoutList: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string.isRequired,
    iconType: _propTypes.default.string
  })),
  breakdownList: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.string,
    price: _propTypes.default.string
  })),
  flyoutBreakdownTitle: _propTypes.default.string,
  flyoutBreakdownStrikethroughPrice: _propTypes.default.string,
  flyoutBreakdownPrice: _propTypes.default.string,
  portalElem: _propTypes.default.object,
  partial: _propTypes.default.string,
  trigger: _propTypes.default.oneOf(['click', 'hover']),
  className: _propTypes.default.string
};